/**
 * assistantSummary
 * ----------------
 *
 * October 2026
 *
 * The DOE results for the AI Assistant's page context. The backend turns them into
 * the same experiment data the narrative uses. Chart data is left out.
 */

const MAX_NARRATIVE_CHARS = 6000;

/**
 * The parts of an analysis result the AI needs (/api/doe/narrative, /api/doe/chat).
 * Chart data is left out: it can exceed the server's request size limit.
 *
 * @param {Object} chartData - The analysis result (from /api/doe/analyze).
 */
export function narrativeInput(chartData) {
  if (!chartData) return null;
  return {
    _metadata: chartData._metadata,
    _design: chartData._design,
    fundamental_questions: chartData.fundamental_questions,
  };
}

/**
 * @param {Object} chartData - The analysis result (from /api/doe/analyze).
 * @param {String} narrative - The AI narrative, if one was generated.
 * @param {Object} experiment - The analyzed experiment's picker entry ({name, model_name, date}), if known.
 * @returns {Object|null} {analyzed_experiment, doe_result, narrative}, or null when nothing has been analyzed.
 */
export function summarizeForAssistant(chartData, narrative, experiment) {
  if (!chartData) return null;
  return {
    analyzed_experiment: experiment
      ? { name: experiment.name, model_name: experiment.model_name, run_at: experiment.date }
      : undefined,
    doe_result: narrativeInput(chartData),
    narrative: narrative ? narrative.slice(0, MAX_NARRATIVE_CHARS) : undefined,
  };
}
